module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-UltraLight.e8c79039.woff2";